import React from 'react';
import { Col } from 'antd';
import { Label } from '../../../../../common/Label/Label';
import styles from '../../../Style/DatasetInfo.module.scss';

export const LocationInfoDisplay = ({
  hasDatasets,
  isLocationAvailable,
  waterDepth,
  cellSize,
  isWind,
}: {
  hasDatasets: boolean;
  isLocationAvailable: boolean;
  waterDepth?: string | number;
  cellSize?: string | number;
  isWind: boolean;
}) => {
  if (!hasDatasets) {
    return (
      <Col span={18} className={styles.InfoCol}>
        <Label
          label={'No dataset found (point is outside of coverage)'}
          className={styles.InfoColLabel}
        >
          {''}
        </Label>
      </Col>
    );
  }

  if (isLocationAvailable) {
    return (
      <Col span={12} className={styles.InfoCol}>
        {isWind ? (
          <div className={styles.InfoColLabel}>{''}</div>
        ) : (
          <Label label='Water depth [mMSL]' className={styles.InfoColLabel}>
            <div className={styles.InfoLabel}>{waterDepth}</div>
          </Label>
        )}
        <Label label='Grid cell size [m]' className={styles.InfoColLabelRight}>
          <div className={styles.InfoLabel}>{cellSize}</div>
        </Label>
      </Col>
    );
  }

  return (
    <Col span={12}>
      <div className={styles.depthGridContainer}>
        <div className={styles.InfoCol}>
          <Label
            label='Water depth [mMSL]'
            className={styles.InfoColLabelUnavailable}
          />
          <Label
            label='Grid cell size [m]'
            className={styles.InfoColLabelRightUnavailable}
          />
        </div>
        <div className={styles.additionalInfoText}>
          Point is outside model grid
        </div>
      </div>
    </Col>
  );
};
